class PfPddingProduct extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const variants = this.querySelectorAll(".pf_padding");
        const colors = document.querySelectorAll('.variant-option--swatches .variant-option__button-label--has-swatch');

        // selected variant
        const savedValue =  sessionStorage.getItem("pf-padding-size");
        const selectedVariant = this.querySelector(`.pf_padding[option-value='${savedValue}']`);
        this.handleChange(selectedVariant);

        variants.forEach((variant)=>{
            variant.addEventListener("click", ()=>{
                this.handleChange(variant);
            })
        });

        colors.forEach((color)=>{
            color.addEventListener("click", ()=>{
                this.getVariant();
            })
        });
    }

    handleChange(variant){
        if(!variant) return;
        const variants = this.querySelectorAll(".pf_padding");
        variants.forEach(elm=>elm.classList.remove('active'));
        variant.classList.add('active');

        const optionValue = variant.getAttribute("option-value");

        sessionStorage.setItem("pf-padding-size", optionValue);
        this.getVariant();
    }

    getVariant() {
        const allVariants = JSON.parse(this.getAttribute("data-variants"));
        const size = this.querySelector(".pf_padding.active").getAttribute("option-value");
        const color = this.getColor();

        // console.log("color:", color);
        // console.log("size:", size);

        if (!size || !color) return null;

        const selectedVariant = allVariants.find(v => {
            let title = v.title.toLowerCase();

            // replace Danish color names inside the string
            title = title.replace("hvid", "white");
            title = title.replace("sort", "black");

            return (
                title.includes(size.toLowerCase()) &&
                title.includes(color.toLowerCase())
            );
        }) || null;

        // console.log("selectedVariant:", selectedVariant);


        this.updateForm(selectedVariant?.id);
    }

    getColor() {
        const selectedColor = document.querySelector(
            '.variant-option__button-label--has-swatch input:checked'
        )?.value;

        const lightColors = this.getAttribute("data-light-colors").split(",").map(c => c.trim().toLowerCase());
        const darkColors  = this.getAttribute("data-dark-colors").split(",").map(c => c.trim().toLowerCase());

        if (!selectedColor) return null;

        const color = selectedColor.trim().toLowerCase();

        if (lightColors.includes(color)) {
            return "white";
        }

        if (darkColors.includes(color)) {
            return "black";
        }

        // fallback if not included in either list
        // return "black";
        return null;
    }

    updateForm(variantId, qty = 1) {
        const form = (this.closest("#quick-add-modal-content") || this.closest(".product-details"))?.querySelector("form.shopify-product-form");
        if(!form) return;

        const oldExtra = form.querySelectorAll(".extra-variant-field");
        oldExtra.forEach(el => el.remove());

        if(!variantId) return;

        const wrapper = document.createElement("div");
        wrapper.classList.add("extra-variant-field");
        wrapper.innerHTML = `
            <input type="hidden" name="items[1]id" value="${variantId}">
        `;
        form.appendChild(wrapper);
    }
}

if(!customElements.get('pf-padding-product')){
    customElements.define('pf-padding-product', PfPddingProduct);
}